var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckmarkCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.295 9.60549L11.727 15.6055C11.539 15.8525 11.248 15.9985 10.938 16.0005H10.931C10.624 16.0005 10.334 15.8585 10.144 15.6165L7.712 12.5095C7.372 12.0755 7.448 11.4465 7.883 11.1065C8.317 10.7655 8.947 10.8415 9.287 11.2775L10.92 13.3635L14.704 8.39449C15.038 7.95549 15.665 7.86949 16.106 8.20449C16.545 8.53949 16.63 9.16649 16.295 9.60549ZM12 2.00049C6.477 2.00049 2 6.47749 2 12.0005C2 17.5225 6.477 22.0005 12 22.0005C17.523 22.0005 22 17.5225 22 12.0005C22 6.47749 17.523 2.00049 12 2.00049Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckmarkCircle);
export default __webpack_public_path__ + "static/media/CheckmarkCircle.df8ca34899d39e076d7e4f9471882eed.svg";
export { ForwardRef as ReactComponent };